export default __webpack_public_path__ + "locales/ru/DeleteSelfProfileDialog.json?hash=69045bb0d4d31bfad20e394d22a4701d";